import { useNavigate } from 'react-router-dom';
import AlbumCover from './AlbumCover';

export default function AlbumCard({ album }) {
  const navigate = useNavigate();
  const style = { '--album-accent': album.accent, '--album-accent-soft': hexToSoft(album.accent) };
  return (
    <button
      className="album-card"
      style={style}
      onClick={() => navigate(`/album/${album.id}`)}
      aria-label={`Open ${album.title} by ${album.artist}`}
    >
      <AlbumCover album={album} className="album-card-cover" />
      <div className="album-card-title">{album.title}</div>
      <div className="album-card-artist">{album.artist}</div>
    </button>
  );
}

function hexToSoft(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!m) return 'rgba(255, 90, 31, 0.35)';
  const [r, g, b] = [1, 2, 3].map((i) => parseInt(m[i], 16));
  return `rgba(${r}, ${g}, ${b}, 0.35)`;
}
